
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


try {
    require('jquery-ui');
    require('jquery-ui/ui/widgets/resizable');
    require('jquery-ui/ui/widgets/sortable');
    require('jquery-ui/themes/base/all.css');
} catch (e) {}


$( document ).ready(function() {
    $("#menu-toggle").click(function(e) {
        e.preventDefault();
        $("#wrapper").toggleClass("toggled");
    });
});
